var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"aspect-ratio":"854/480","border-radius":"5px"},attrs:{"width":"100%","src":"https://www.youtube.com/embed/N6w_cJpLBps","title":"YouTube video player","frameborder":"0","allowfullscreen":""}})])
}]

export { render, staticRenderFns }